import React from "react"

import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"
import ContentWidth from "./ContentWidth"
import StyledLink from "./StyledLink"
import LightboxBtn from "./LightboxBtn"
import GlobalButton from "./buttons/GlobalButton"
import Check from "images/SmallCheck.svg"

const ImgContent = ({ content }) => {
  return (
    <ContentWidth>
      <Wrapper>
        {content?.card ? (
          <CardBackground on={content.card}>
            <ContentDiv side={content.contentSide}>
              <CopyDiv
                $imageHeader={content?.imageHeader}
                $centered={content?.centered}
              >
                {content?.eyebrow && <Eyebrow>{content?.eyebrow}</Eyebrow>}
                {content?.headline && !content.imageHeader && (
                  <Header>{content?.headline}</Header>
                )}
                {content?.imageHeader && content.headerImage && (
                  <HeaderImg
                    src={content?.headerImage?.sourceUrl}
                    alt={content?.headerImage?.altText}
                  />
                )}
                {content?.bodyCopy && (
                  <Body
                    $olNostyle={content.unstyledOrderedList}
                    dangerouslySetInnerHTML={{ __html: content.bodyCopy }}
                  />
                )}
                {content?.linkText &&
                  content?.button !== true &&
                  !content?.pillCta && (
                    <StyledLink href={content.linkUrl}>
                      {content?.linkText}
                    </StyledLink>
                  )}
                {content?.button && (
                  <GlobalButton
                    fill
                    href={content?.linkUrl}
                    target={content?.externalLink ? "_blank" : "_self"}
                  >
                    {content.linkText}
                  </GlobalButton>
                )}
              </CopyDiv>
              {content?.image && (
                <Image
                  alt={content?.image?.altText}
                  top={content?.imageTop}
                  src={content?.image?.sourceUrl}
                />
              )}
            </ContentDiv>
          </CardBackground>
        ) : (
          <ContentDiv side={content.contentSide}>
            <CopyDiv
              $imageHeader={content?.imageHeader}
              $centered={content?.centered}
            >
              {content?.eyebrow && <Eyebrow>{content?.eyebrow}</Eyebrow>}
              {content?.headline && !content?.imageHeader && (
                <Header>{content?.headline}</Header>
              )}
              {content?.imageHeader && content.headerImage && (
                <HeaderImg
                  src={content?.headerImage?.sourceUrl}
                  alt={content?.headerImage?.altText}
                />
              )}
              {content?.bodyCopy && (
                <Body
                  $olNoStyle={content?.unstyledOrderedList}
                  boldSpacing={content?.headerImage}
                  dangerouslySetInnerHTML={{ __html: content.bodyCopy }}
                />
              )}
              {content?.linkText &&
                content?.button !== true &&
                !content?.pillCta && (
                  <StyledLink href={content.linkUrl}>
                    {content?.linkText}
                  </StyledLink>
                )}
              {content?.button && (
                <GlobalButton
                  fill
                  href={content?.linkUrl}
                  target={content?.externalLink ? "_blank" : "_self"}
                >
                  {content.linkText}
                </GlobalButton>
              )}
              {content.formId && (
                <LightboxBtn
                  formId={content.formId}
                  lightboxText={content?.formButtonText}
                  ty={content?.formThankYou}
                />
              )}
            </CopyDiv>
            {content?.image && (
              <Image
                alt={content?.image?.altText}
                top={content?.imageTop}
                src={content?.image?.sourceUrl}
              />
            )}
          </ContentDiv>
        )}
      </Wrapper>
    </ContentWidth>
  )
}

export default ImgContent

const Image = styled.img`
  display: flex;
  border-radius: 0.833vw;
  align-self: ${props => (props.top ? "start" : "unset")};
  height: auto;
  width: 35.694vw;
  ${media.fullWidth} {
    width: 514px;
    border-radius: 12px;
  }

  ${media.tablet} {
    width: 44.727vw;
    border-radius: 1.172vw;
  }

  ${media.mobile} {
    width: 87.85vw;
    border-radius: 2.804vw;
  }
`
const Link = styled.a`
  ${text.bodyMdBold};
`
const Body = styled.p`
  ${text.bodyMd};
  height: max-content;

  p {
    strong {
      ${text.bodyMdBold};
    }

    margin-bottom: 1.667vw;

    ${media.fullWidth} {
      margin-bottom: 24px;
    }

    ${media.tablet} {
      margin-bottom: 2.344vw;
    }

    ${media.mobile} {
      margin-bottom: 5.607vw;
    }
  }

  ul {
    list-style: none;
    margin-left: 0.347vw;
    margin-top: 2.778vw;
    margin-bottom: 2.778vw;

    ${media.fullWidth} {
      margin-left: 5px;
      margin-top: 40px;
      margin-bottom: 40px;
    }

    ${media.tablet} {
      margin-left: 0.488vw;
      margin-top: 3.906vw;
      margin-bottom: 3.906vw;
    }

    ${media.mobile} {
      margin-left: 1.168vw;
      margin-top: 9.346vw;
      margin-bottom: 9.346vw;
    }

    li {
      background-image: url(${Check});
      background-repeat: no-repeat;
      padding-left: 3.472vw;
      background-size: 2.5vw 2.5vw;
      margin-bottom: 1.667vw;
      min-height: 2.5vw;

      ${media.fullWidth} {
        padding-left: 50px;
        background-size: 36px 36px;
        margin-bottom: 7px;
        min-height: 36px;
      }

      ${media.tablet} {
        padding-left: 5.465vw;
        background-size: 3.516vw 3.516vw;
        margin-bottom: 0.684vw;
        min-height: 4.5vw;
      }

      ${media.mobile} {
        padding-left: 10.505vw;
        background-size: 8.411vw 8.411vw;
        margin-bottom: 1.636vw;
        min-height: 8.5vw;
      }
    }
  }

  ol {
    position: relative;
    list-style: ${props => (props.$olNoStyle ? "decimal" : "none")};
    counter-reset: list-number;
    margin-left: ${props => (props.$olNoStyle ? "1.402vw" : "3.472vw")};
    margin-top: 2.778vw;
    margin-bottom: 2.778vw;

    ${media.fullWidth} {
      margin-left: ${props => (props.$olNoStyle ? "6px" : "50px")};
      margin-top: 40px;
      margin-bottom: 40px;
    }

    ${media.tablet} {
      margin-left: ${props => (props.$olNoStyle ? "1.865vw" : "4.883vw")};
      margin-top: 3.906vw;
      margin-bottom: 3.906vw;
    }

    ${media.mobile} {
      margin-left: ${props => (props.$olNoStyle ? "5.103vw" : "11.682vw")};
      margin-top: 9.346vw;
      margin-bottom: 9.346vw;
    }

    li {
      min-height: 2.5vw;
      margin-bottom: ${props => (props.$olNoStyle ? "unset" : "1.667vw")};

      ${media.fullWidth} {
        min-height: 36px;
        margin-bottom: ${props => (props.$olNoStyle ? "unset" : "24px")};
      }

      ${media.tablet} {
        min-height: 3.516vw;
        margin-bottom: ${props => (props.$olNoStyle ? "unset" : "2.344vw")};
      }

      ${media.mobile} {
        min-height: 8.411vw;
        margin-bottom: ${props => (props.$olNoStyle ? "unset" : "5.607vw")};
      }
    }
    ${props =>
      !props.$olNoStyle &&
      `li::before {
      position: absolute;
      left: -4vw;
      content: counter(list-number);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      color: ${colors.primaryOrange};
      margin-right: 0.694vw;
      width: 2.5vw;
      height: 2.5vw;
      font-size: 1.25vw;
      border: 0.25vw solid ${colors.primaryOrange};

      ${media.fullWidth} {
        left: -58px;
        margin-right: 10px;
        width: 36px;
        height: 36px;
        font-size: 18px;
        border: 3px solid ${colors.primaryOrange};
      }

      ${media.tablet} {
        left: -5vw;
        margin-right: 0.977vw;
        width: 3.516vw;
        height: 3.516vw;
        font-size: 1.758vw;
        border: 0.293vw solid ${colors.primaryOrange};
      }

      ${media.mobile} {
        left: -11vw;
        margin-right: 2.336vw;
        width: 8.411vw;
        height: 8.411vw;
        font-size: 4.206vw;
        border: 0.701vw solid ${colors.primaryOrange};
      }
    }
    `}

    li {
      counter-increment: list-number;
    }
  }
`
const HeaderImg = styled.img`
  height: 9.097vw;
  width: 31.944vw;
  padding-bottom: 1.667vw;

  ${media.fullWidth} {
    height: 131px;
    width: 460px;
    padding-bottom: 24px;
  }

  ${media.tablet} {
    height: 12.793vw;
    width: 100%;
    padding-bottom: 2.344vw;
  }

  ${media.mobile} {
    width: 100%;
    height: 26.402vw;
  }
`

const Header = styled.h3`
  ${text.h3};
`
const Eyebrow = styled.p`
  ${text.eyebrow};
`
const CopyDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => (props.$imageHeader ? "unset" : "1.667vw")};
  width: 39.167vw;
  align-items: ${props => (props.$centered ? "center" : "unset")};
  justify-content: ${props => (props.$centered ? "center" : "unset")};

  ${media.fullWidth} {
    gap: ${props => (props.$imageHeader ? "unset" : "24px")};
    width: 564px;
  }
  ${media.tablet} {
    gap: 2.344vw;
    width: 41.016vw;
  }

  ${media.mobile} {
    gap: 5.607vw;
    width: 87.85vw;
    align-items: ${props => (props.$centered ? "unset" : "unset")};
  }
`
const ContentDiv = styled.div`
  display: flex;
  flex-direction: ${props => (props.side === "left" ? "row" : "row-reverse")};
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 4.583vw;

  ${media.fullWidth} {
    gap: 66px;
  }

  ${media.tablet} {
    gap: 6.445vw;
  }

  ${media.mobile} {
    flex-direction: column-reverse;
    align-items: unset;
    gap: 7.477vw;
  }
`
const CardBackground = styled.div`
  background-color: ${props => (props.on ? colors.grey25 : "unset")};
  padding: 5.556vw 4.722vw;
  border-radius: 1.667vw;

  ${media.fullWidth} {
    padding: 80px 68px;
    border-radius: 24px;
  }

  ${media.tablet} {
    padding: 3.906vw 2.539vw;
    border-radius: 2.344vw;
  }

  ${media.mobile} {
    width: 100%;
    border-radius: unset;
  }
`
const Wrapper = styled.div``
